import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

export const useSeo = () => {
  const { slug } = useParams();
  const [state, setstate] = useState({});
  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res;
  };
  const renderDesc = () => {
    if (!state.loading) {
      if (state.data.data.seo && state.data.data.seo.seoDescription) {
        return state.data.data.seo.seoDescription;
      } else {
        return renderSlug(slug);
      }
    }
  };

  const rendeKeyWords = () => {
    let res = "";
    if (!state.loading) {
      if (
        state.data.data.seo &&
        state.data.data.seo.seoKeyword &&
        Array.isArray(state.data.data.seo.seoKeyword)
      ) {
        state.data.data.seo.seoKeyword.map((key, count) => {
          if (state.data.data.seo.seoKeyword.length - 1 == count) {
            res = res + key;
          } else {
            res = res + key + ",";
          }
        });
        return res;
      } else {
        return renderSlug(slug);
      }
    }
  };
};

export const useCountdown = targetDate => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = countDown => {
  const isEnd = false;
  if (countDown <= 0) {
    isEnd = true;
  }
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds, isEnd];
};
export const useQuery = ({ filters = [{ key: "page" }] }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const changeObj = (key, value) => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    setSearchParams({ ...obj, [key]: value });
  };
  const createObjFilter = () => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    return obj;
  };
  const getValue = key => {
    return key ? searchParams.get(key) || "" : "";
  };
  const clear = () => {
    setSearchParams({});
  };
  return { changeObj, searchParams, createObjFilter, getValue, clear };
};
